import { v4 as uuidv4 } from "uuid";

import ReactDOM from "react-dom";
import { makeAutoObservable, reaction } from "mobx";
import { observer } from "mobx-react-lite";
import { FoodItemProperties } from "../../Resources/Constants";
import Food from "./Food";

class FoodOption {
  foods = [];
  isSelected = false;

  isShowingFoods = true;

  constructor(id = uuidv4(), order = 0, meal = null) {
    this.id = id;
    this.order = order;
    this.meal = meal;
    makeAutoObservable(this);
  }

  uploadToCloud() {
    let foodsArray = this.foods.map((food) => food.uploadToCloud());

    return {
      id: this.id.toString().toLowerCase(),
      order: this.order,
      foods: foodsArray,
    };
  }

  fetchFood(foodData) {
    const newFood = new Food(
      foodData.id,
      foodData.name,
      foodData.order,
      foodData.quantity,
      foodData.calories,
      foodData.carbs,
      foodData.protein,
      foodData.fats,
      foodData.code ?? undefined,
      null,
      null,
      this
    );

    foodData?.equivalences?.forEach((food) => {
      newFood.fetchEquivalence(food);
    });

    this.foods.push(newFood);
  }

  get isDefault() {
    if (this.meal) {
      return this.meal.defaultFoodOption === this.order;
    }
    return false;
  }

  get totalCalories() {
    return this.foods.reduce((acc, f) => acc + (Number(f.getCalories) || 0), 0);
  }

  get totalCarbs() {
    return this.foods.reduce((acc, f) => acc + (Number(f.getCarbs) || 0), 0);
  }

  get totalProtein() {
    return this.foods.reduce((acc, f) => acc + (Number(f.getProtein) || 0), 0);
  }

  get totalFats() {
    return this.foods.reduce((acc, f) => acc + (Number(f.getFats) || 0), 0);
  }

  deleteFood(foodId) {
    const idx = this.foods.findIndex((f) => f.id === foodId);

    if (idx > -1) {
      // already selected → remove it
      this.foods.splice(idx, 1);
    }
  }

  addFoodItem(foodItem, historyFood) {
    const maxOrder = this.foods.length
      ? Math.max(...this.foods.map((f) => f.order))
      : -1;
    const newOrder = maxOrder + 1;

    if (historyFood) {
      const newFoodToAdd = new Food(
        uuidv4(),
        historyFood.name,
        newOrder,
        undefined,
        historyFood.calories,
        historyFood.carbs,
        historyFood.protein,
        historyFood.fats,
        historyFood.code,
        historyFood.brand,
        historyFood.store,
        this
      );

      newFoodToAdd.setProperty("code", historyFood.code);

      this.foods.push(newFoodToAdd);
    } else {
      const newFoodToAdd = new Food(
        uuidv4(),
        foodItem.product_name || foodItem.generic_name,
        newOrder,
        undefined,
        foodItem.nutriments?.[FoodItemProperties.CALORIES],
        foodItem.nutriments?.[FoodItemProperties.CARBS],
        foodItem.nutriments?.[FoodItemProperties.PROTEIN],
        foodItem.nutriments?.[FoodItemProperties.FAT],
        foodItem.code, //Revisar!!!!
        foodItem.brands,
        foodItem.stores,
        this
      );

      newFoodToAdd.setProperty("code", foodItem.code);

      this.foods.push(newFoodToAdd);

      if (
        this.meal &&
        this.meal.nutritionPlan &&
        this.meal.nutritionPlan.client
      ) {
        const client = this.meal.nutritionPlan.client;
        const history = client.foodHistory;

        const alreadyInHistory = history.some(
          (f) => f.code === newFoodToAdd.code
        );
        if (!alreadyInHistory) {
          const newLastUsedFood = new Food(
            uuidv4(),
            newFoodToAdd.name,
            newOrder,
            undefined,
            newFoodToAdd.calories,
            newFoodToAdd.carbs,
            newFoodToAdd.protein,
            newFoodToAdd.fats,
            newFoodToAdd.code,
            newFoodToAdd.brand,
            newFoodToAdd.store,
            null,
            client
          );
          newLastUsedFood.setProperty("code", newFoodToAdd.code);

          history.push(newLastUsedFood);

          // **keep only the last 20 items**
          if (history.length > 20) {
            history.shift();
          }
        }
      }
    }
  }

  selectFoodItem(foodItem) {
    // guard against missing code
    if (!foodItem.code) return;

    // find the index of the item in foods
    const idx = this.foods.findIndex((f) => f.code === foodItem.code);

    if (idx > -1) {
      // already selected → remove it
      this.foods.splice(idx, 1);
    } else {
      // not selected → add it
      this.addFoodItem(foodItem);
    }
  }

  selectHistoryFood(historyFood) {
    //Utilitzar selectFoodItem passant un bool o algo i eliminar aixo
    // guard against missing code
    if (!historyFood.code) return;

    // find the index of the item in foods
    const idx = this.foods.findIndex((f) => f.code === historyFood.code);

    if (idx > -1) {
      // already selected → remove it
      this.foods.splice(idx, 1);
    } else {
      // not selected → add it
      this.addFoodItem(null, historyFood);
    }
  }

  // Generic setter
  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  // Generic getter
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default FoodOption;
